import { render, staticRenderFns } from "./BaseStaffRow.vue?vue&type=template&id=15da8448&"
import script from "./BaseStaffRow.vue?vue&type=script&lang=js&"
export * from "./BaseStaffRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports